<template>
  <div>
    <SubNav />
    <!-- Main Header Section -->
    <div class="flex items-center justify-center text-navy font-futura text-5xl sm:text-7xl mt-20 sm:mt-40 text-center px-4">
      <div class="block">
        <p>WHERE WE SHARE OUR</p>
        <p class="sm:ml-16">STORIES & IDEAS</p>
      </div>
    </div>

    <!-- Category Buttons -->
    <!-- <div class="flex flex-wrap justify-center gap-2 sm:gap-4 mt-10 px-4">
      <label>
        <input type="radio" name="category" value="all" class="hidden" v-model="selectedCategory" />
        <span
          :class="['inline-block px-4 py-2 border border-lightTangerine text-navy hover:bg-tangerine hover:text-white', selectedCategory === 'all' ? 'bg-tangerine text-white' : 'border-tangerine text-navy']">
          ALL TOPICS
        </span>
      </label>
      <label>
        <input type="radio" name="category" value="Startups" class="hidden" v-model="selectedCategory" />
        <span
          :class="['inline-block px-4 py-2 border border-lightTangerine text-navy hover:bg-tangerine hover:text-white', selectedCategory === 'Startups' ? 'bg-tangerine text-white' : 'border-tangerine text-navy']">
          STARTUPS
        </span>
      </label>
      <label>
        <input type="radio" name="category" value="Weekly Round-ups" class="hidden" v-model="selectedCategory" />
        <span
          :class="['inline-block px-4 py-2 border border-lightTangerine text-navy hover:bg-tangerine hover:text-white', selectedCategory === 'Weekly Round-ups' ? 'bg-tangerine text-white' : 'border-tangerine text-navy']">
          WEEKLY ROUND-UPS
        </span>
      </label>
      <label>
        <input type="radio" name="category" value="Hanga Pitch Fest" class="hidden" v-model="selectedCategory" />
        <span
          :class="['inline-block px-4 py-2 border border-lightTangerine text-navy hover:bg-tangerine hover:text-white', selectedCategory === 'Hanga Pitch Fest' ? 'bg-tangerine text-white' : 'border-tangerine text-navy']">
          HANGA PITCH FEST
        </span>
      </label>
    </div> -->

    <!-- Blog Cards -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4 mt-12 sm:mt-20 ml-4 sm:ml-12 mr-4 sm:mr-12">
      <div
        v-for="blog in filteredBlogs"
        :key="blog.id"
        class="relative overflow-hidden shadow-md cursor-pointer"
        @click="viewBlog(blog)"
      >
        <!-- Blog cover image -->
        <img
          :src="blog.image"
          alt="Blog Image"
          class="w-full h-[300px] sm:h-[400px] object-cover"
        />

        <!-- Blog title and description overlay -->
        <div
          class="absolute inset-0 text-white p-4 flex flex-col justify-end"
          style="background: linear-gradient(to top, rgba(1, 9, 48, 0.76) 0%, rgba(1, 9, 48, 0.76) 30%, rgba(1, 9, 48, 0.2) 70%);"
        >
          <button
            class="text-black bg-white absolute top-0 mt-4 font-gramatika text-md sm:text-lg p-1 sm:p-2 px-4 sm:px-6 w-fit">
            {{ blog.category }}
          </button>
          <h2 class="text-xl sm:text-3xl font-futura">{{ blog.title }}</h2>
          <p class="text-xl sm:text-3xl font-futura">{{ blog.episode }}</p>
          <p class="text-sm mt-2 font-gramatika">{{ blog.content.substring(0, 100) }}...</p>
          <div class="flex space-x-2 mt-2 text-sm sm:text-md">
            <p class="font-bold font-futura">{{ formatDate(blog.date) }} .</p>
            <p class="font-bold font-futura">{{ blog.author }}</p>
          </div>
        </div>
      </div>
    </div>

    <NewsLetter />
    <footerPage />
  </div>
</template>

<script>
import client from '../contentful'; 
import SubNav from '@/components/SubNav.vue';
import NewsLetter from '@/components/NewsLetter.vue';
import footerPage from '@/components/footerPage.vue';

export default {
  components:{
      SubNav,
      NewsLetter,
      footerPage
  },
  data() {
    return {
      blogs: [], // To store all blogs from Contentful
      selectedCategory: 'all', // Default selected category
    };
  },
  computed: {
    filteredBlogs() {
      // Filter by category if not 'all'
      let filtered = this.blogs;
      if (this.selectedCategory !== 'all') {
        filtered = filtered.filter(blog => blog.category === this.selectedCategory);
      }
      
      // Sort by date (newest first) and limit to 30
      return filtered
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, 30);
    }
  },
  async created() {
    try {
      const response = await client.getEntries({ 
        content_type: "blogPost",
        order: '-fields.date', // Get newest first from Contentful
        limit: 30 // Only fetch 30 most recent initially
      });
      
      this.blogs = response.items
        .filter((item) => item.fields) 
        .map((item) => ({
          id: item.sys.id,
          date: item.fields.date || new Date().toISOString(),
          category: item.fields.category || 'Uncategorized',
          author: item.fields.author || 'Unknown Author',
          episode: item.fields.episode || '',
          title: item.fields.title || "Untitled",
          image: item.fields.blogImage 
            ? `https:${item.fields.blogImage.fields.file.url}` 
            : require('@/assets/faqbg.jpg'),
          content: item.fields.blogDesc || "No description available.",
        }));
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  },
  methods: {
    viewBlog(blog) {
      this.$router.push({ name: 'BlogDetails', params: { id: blog.id } });
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    }
  },
};
</script>

